import { ProductFaq } from '@/domain/products/types';
import { Typography } from '@andritzot/metris-web-ui/data-display/typography';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { Accordion, AccordionDetails, AccordionSummary } from '@andritzot/metris-web-ui/surfaces/accordion';

interface FaqContentProps {
  productFaq: ProductFaq[];
}

const readonlySxStyle = {
  '& .MuiOutlinedInput-root': {
    '& fieldset': { border: 'none' },
    '&:hover fieldset': { border: 'none' },
    '&.Mui-focused fieldset': { border: 'none' },
  },
};

export const FaqContent = ({ productFaq }: FaqContentProps) => {
  const sortedFaq = [...productFaq].sort((a, b) => a.order - b.order);

  return (
    <Box sx={{ backgroundColor: '#fff' }}>
      {sortedFaq.map((faq) => (
        <Accordion key={faq.id} defaultExpanded={false} disableGutters>
          <AccordionSummary sx={{ backgroundColor: '#fff', boxShadow: 'none', border: 'none' }}>
            <Typography sx={{ mr: 4 }}>#{faq.order}</Typography>
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ backgroundColor: '#fff' }}>
            <TextField
              label="Answer"
              value={faq.answer}
              multiline
              slotProps={{ htmlInput: { readOnly: true } }}
              sx={readonlySxStyle}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </Box>
  );
};
